import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { useTooltipControllerSharedState } from './useTooltipControllerSharedState';
import { useTooltipControllerOpen } from './useTooltipControllerOpen';
import { useTooltipControllerTouch } from './useTooltipControllerTouch';
export function useTooltipController(props) {
  const {
    children
  } = props;
  const childrenRef = React.useRef(null);
  const handleChildrenRef = useForkRef(children.ref, childrenRef);
  const state = useTooltipControllerSharedState();
  const {
    open,
    handleClose,
    createHandleEnter,
    handleLeave
  } = useTooltipControllerOpen({
    props,
    state,
    childrenRef
  });
  const handleEnterForward = createHandleEnter(true);
  const {
    handleTouchStart,
    handleTouchEnd
  } = useTooltipControllerTouch({
    props,
    state,
    handleEnter: handleEnterForward,
    handleClose
  });
  const childrenProps = _objectSpread(_objectSpread({}, children.props), {}, {
    onMouseEnter: handleEnterForward,
    onMouseLeave: handleLeave,
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    ref: handleChildrenRef
  });
  return {
    open,
    childrenProps,
    tooltipProps: {
      open,
      anchorRef: childrenRef,
      onMouseLeave: handleLeave,
      onMouseEnter: createHandleEnter(false)
    }
  };
}